<div class="widgetLineWidget widgetLine">
  <table aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-with-space {{widgetBackgroundColorClass}}">
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>

        <th class="widget-grid-space">&nbsp;</th>

        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tr *ngIf="widgetBackgroundColorClass">
      <td colspan="33" class="widget-line-title-height {{widgetBackgroundColorClass}}">
        <div class="text-input">

          <div class="dropdown-item" *ngIf="editMode">
            <kendo-dropdownlist style="width: 300px;"></kendo-dropdownlist>
          </div>

          <div class="text-item" [style.width]="editMode ? 'calc(98% - 305px)' : '98%'">

            <input type="text"
                   *ngIf="editMode"
                   [(ngModel)]="widgetConfig.widgetSettings.title"
                   maxlength="50"
                   class="border-none widget-line-text gridster-item-content {{widgetBackgroundColorClass}}" />

            <div *ngIf="!editMode" class="view-mode-title border-none widget-line-text {{widgetBackgroundColorClass}}">
              {{ widgetConfig.widgetSettings.title }}
            </div>

          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
